export default __webpack_public_path__ + "static/media/you-can-do-it-1440w.7945dcfd.webp";